import { useApolloClient } from "@apollo/client";
import {
  FilterChipGroupProps,
  FilterChipGroup,
} from "../../commons/filters/FilterChip.js";
import { getPersonLabel } from "../users/helpers.js";
import { UserAvatar } from "../users/UserAvatar.js";
import { useFilterOrganisationMembersChipsQuery } from "./FilterOrganisationMembersChips.generated.js";

export function FilterOrganisationMembersChips(
  props: Omit<FilterChipGroupProps<string>, "getValueLabel">
) {
  const client = useApolloClient();
  const query = useFilterOrganisationMembersChipsQuery({
    client,
    fetchPolicy: "network-only",
    variables: {
      userIds: props.values
        ? Array.isArray(props.values)
          ? props.values
          : [props.values]
        : [],
    },
  });
  const activeMembers =
    (query?.data ?? query?.previousData)?.organisationMemberships.edges.map(
      edge => edge.node
    ) ?? [];

  return (
    <FilterChipGroup
      {...props}
      getValueLabel={value => {
        const member = activeMembers.find(u => u.id === value);
        if (member) return getPersonLabel(member, false);
        return "–";
      }}
      getAvatar={value => {
        const member = activeMembers.find(u => u.id === value);
        if (member)
          return (
            <UserAvatar
              size="xs"
              userAvatar={member}
              sx={{ ml: 0.5, mr: -0.5 }}
            />
          );
      }}
    />
  );
}
